// TODO удалить, когда перейдём на Nuxt 3
/*
  Т.к. пока мы используем Nuxt 2, когда в шаблоне мы используем функции, компилятор ругается (например компонент-страница SalePage)
  Чтобы не было таких ошибок в темплейте, мы ввели эту функцию обёртку
*/
export default function wrapFunc(fn: (element?: any) => unknown) {
  return fn
}
